import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '@custom/store/store';
import { getExtraStorage } from '@custom/rtk-apis/Setting/extraStorage/getExtraStorage';
import { CheckIcon } from '@custom/Hospital/PricingCard/icons';
import { useTheme } from '../../../ui/src/contextProviders';
import { Loader } from '@ohif/ui';

interface ExtraStoragePopupProps {
  isOpen: boolean;
  onClose: () => void;
  onPlanSelect: (plan: any) => void;
  creditValue: number;
  currentPlan : string
}

const ExtraStoragePopup: React.FC<ExtraStoragePopupProps> = ({ isOpen, onClose, onPlanSelect, creditValue = 0, currentPlan }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { isDarkMode } = useTheme();

  const getExtraStorageResponse = useSelector((state: RootState) => state.getExtraStorageResponse);
  const plans = getExtraStorageResponse?.result?.plans || [];

  const [selectedPlanId, setSelectedPlanId] = useState<string | null>(null);

  useEffect(() => {
    if (isOpen) {
      dispatch(getExtraStorage());
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const togglePlan = (planId: string) => {
    setSelectedPlanId(planId);
  };

  const handleContinue = () => {
    const plan = plans.find((p: any) => p.id === selectedPlanId);
    if (!plan) return;
    onPlanSelect(plan);
  };

  return (
    <div className={`addon-modal-overlay ${isDarkMode ? 'dark-mode' : ''}`} onClick={onClose}>
      <div
        className={`addon-modal-content ${isDarkMode ? 'dark-mode' : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={`addon-modal-header ${isDarkMode ? 'dark-mode' : ''}`}>
          <h2 className={isDarkMode ? 'dark-mode' : ''}>Select Extra Storage Plan</h2>
          <button className={`close-button ${isDarkMode ? 'dark-mode' : ''}`} onClick={onClose}>
            ×
          </button>
        </div>

        <div className="addon-cards-container">
          {plans?.map((plan: any, index: number) => {
          return  <div
              className={`addon-card ${selectedPlanId === plan.id ? 'selected' : ''} ${isDarkMode ? 'dark-mode' : ''}`}
              key={plan.id}
              onClick={() => togglePlan(plan.id)}
            >
              <div className="addon-card-checkbox">
               <input
                  type="radio"
                  checked={selectedPlanId === plan.id}
                  onChange={() => togglePlan(plan.id)}
                  onClick={(e) => e.stopPropagation()}
                />
              </div>

              <div className={`addon-card-header ${isDarkMode ? 'dark-mode' : ''}`}>
                <h3 className={isDarkMode ? 'dark-mode' : ''}>{plan.planName}</h3>
                {/* rupees symbol */}

                <p className="price"><span className="rupee-symbol">₹</span> {plan.creditsPerGB * creditValue} /GB</p>
              </div>

              <div className={`addon-card-body ${isDarkMode ? 'dark-mode' : ''}`}>
                <ul className="features-list">
                  <li className={`feature-item ${isDarkMode ? 'dark-mode' : ''}`}>
                    <CheckIcon />
                    <span className={isDarkMode ? 'dark-mode' : ''}>{plan.frequency} months</span>
                  </li>
                  <li className={`feature-item ${isDarkMode ? 'dark-mode' : ''}`}>
                    <CheckIcon />
                    <span className={isDarkMode ? 'dark-mode' : ''}>{plan.creditsPerGB} credits/GB</span>
                  </li>
                </ul>
              </div>
              {currentPlan == plan.planName &&
              <button
               className="mt-4 bg-[#0F8491] px-4 py-2 rounded bg-gray-300 text-md text-white font-medium cursor-not-allowed"
               disabled
              >
                Current Plan
              </button>}
            </div>
        })}
        </div>

        <div className="addon-modal-footer">
          <button className="btn btn__primary" disabled={!selectedPlanId} onClick={handleContinue}>
            Continue
          </button>
        </div>
      </div>
      <Loader
        isLoaderOpen={getExtraStorageResponse?.loading}
      />
    </div>
  );
};

export default ExtraStoragePopup;
